import { render, staticRenderFns } from "./AboutStudy.vue?vue&type=template&id=38f0939e&scoped=true"
import script from "./AboutStudy.vue?vue&type=script&lang=js"
export * from "./AboutStudy.vue?vue&type=script&lang=js"
import style0 from "./AboutStudy.vue?vue&type=style&index=0&id=38f0939e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0939e",
  null
  
)

export default component.exports